const PUBLIC_SAAS_PATHS = new Set([
    '/plans',
    '/plans/embed',
    '/signup',
    '/auth/action',
    '/checkout/return',
]);

// These pages own pre-provisioning Authentication and must not require a Therapist grant yet.
export function isPublicSaasPath(pathname: string): boolean {
    const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    return PUBLIC_SAAS_PATHS.has(normalizedPath);
}
